import type { FC } from "react";
import { getDropDownButtonTitle } from "app/components/duration-selector/DurationSelectorUtils";
import type { IDropdownItem } from "@similarweb/ui-components";

interface IDurationSelectorSidebarButtonProps {
    initialPreset: string;
    presets: IDropdownItem[];
    compareSelected: boolean;
    disabled?: boolean;
    onClick?: () => void;
    onSelect?: () => void;
}

export const DurationSelectorSidebarButton: FC<IDurationSelectorSidebarButtonProps> = (props) => {
    let style: any = {
        lineHeight: "60px",
    };
    if (props.disabled) {
        style = { ...style, pointerEvents: "none", cursor: "auto" };
    }
    return (
        <div
            style={style}
            onClick={props.onClick}
        >
            {getDropDownButtonTitle(props.initialPreset, props.presets)}
            {props.compareSelected ? <span className="isCompareBullet" /> : null}
        </div>
    );
};

DurationSelectorSidebarButton.displayName = "DurationSelectorSidebarButton";
